import React from "react"
import { BottomModalBase, Button } from "@components"
import { View, StyleSheet } from "react-native"
import { Theme } from "@theme"
import { useTheme } from "@react-navigation/native"
import { useLanguage } from "@context"
import ContactsList from "./ContactsList"

const AddContactsModal = ({isVisible, setIsVisible, title, multiple = true, selectedContactIds, fitParent = false, includeGhost = false, setSelectedContactIds}: {isVisible: boolean, setIsVisible: React.Dispatch<React.SetStateAction<boolean>>, title?: string, multiple?: boolean, selectedContactIds?: string[], fitParent?: boolean, includeGhost?: boolean, setSelectedContactIds?: React.Dispatch<React.SetStateAction<string[]>>}) => {
  const theme = useTheme();
  const styles = getStyle(theme);
  const { t } = useLanguage();

  return (
    <BottomModalBase isVisible={isVisible} setIsVisible={setIsVisible} largePaddingTop={false} hasCloseButton fitParent={fitParent}>
      <View style={[styles.modalContainer, fitParent && styles.fullHeight]}>
        <ContactsList isEdit={false} title={title} multiple={multiple} selectedContactIds={selectedContactIds || []} setSelectedContactIds={setSelectedContactIds || (() => {})} fitParent={fitParent} includeGhost={includeGhost}/>
        {/* Validate the (already-applied) selection and close — clearer than
            having to find the X to dismiss. */}
        <View style={styles.footer}>
          <Button
            title={t('common.save')}
            onPress={() => setIsVisible(false)}
            isSmall
            style={styles.saveButton}
          />
        </View>
      </View>
    </BottomModalBase>
  )
}

const getStyle = (theme: Theme) =>
    StyleSheet.create({
        modalContainer: {
            flex: 1,
            paddingTop: 16,
            width: '100%',
            backgroundColor: theme.colors.white,
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
        },
        fullHeight: {
            height: '100%',
        },
        footer: {
            alignItems: 'center',
            paddingHorizontal: theme.spacing.lg,
            paddingTop: theme.spacing.md,
            paddingBottom: theme.spacing.lg,
            borderTopWidth: 1,
            borderTopColor: theme.colors.grey10,
            backgroundColor: theme.colors.white,
        },
        saveButton: {
            minWidth: 220,
            paddingHorizontal: theme.spacing.xxxl,
        },
    });

export default AddContactsModal
